var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    { staticClass: "px-sm-0 pl-xl-3 mt-lg-3 mt-xl-0 col-12 col-xl-10" },
    [
      _c(
        "fieldset",
        { staticClass: "border border-primary p-2 rounded" },
        [
          _c(
            "legend",
            {
              staticClass:
                "w-auto px-2 font-weight-bold smaller-font-content text-primary"
            },
            [_vm._v("UPDATE: DEFAULT LOGIN")]
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "container",
              attrs: {
                id: _vm.subItem.CarrierName + "_carrier_fields",
                "label-for": ""
              }
            },
            [
              _c("div", { staticClass: "credentials row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "credential-field col-12 col-md-6 col-lg-4 col-xl-3 order-1",
                    on: {
                      click: function($event) {
                        return _vm.clearErrors("username")
                      }
                    }
                  },
                  [
                    _c("div", [
                      _c("label", [
                        _vm._v("Username"),
                        _c("span", { staticClass: "star" }, [_vm._v("*")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("b-form-input", {
                      attrs: {
                        id: _vm.subItem.CarrierName + "username",
                        name: "username",
                        type: "text",
                        autocomplete: "new-password"
                      },
                      model: {
                        value: _vm.form.username,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "username",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.username"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "errorsection" }, [
                      _c(
                        "label",
                        {
                          staticClass: "text-error-msg",
                          style: {
                            visibility: _vm.errorFields.usernameError
                              ? "visible"
                              : "hidden"
                          }
                        },
                        [_vm._v(_vm._s(_vm.errorFields.usernameError))]
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "credential-field col-12 col-md-6 col-lg-4 col-xl-3 order-2",
                    on: {
                      click: function($event) {
                        return _vm.clearErrors("newPassword")
                      }
                    }
                  },
                  [
                    _c("div", [
                      _c("label", [
                        _vm._v("New Password"),
                        _c("span", { staticClass: "star" }, [_vm._v("*")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "password-field" },
                      [
                        _c("b-form-input", {
                          staticClass: "password-input",
                          attrs: {
                            id: _vm.subItem.CarrierName + "new-password",
                            name: "new-password",
                            type: _vm.newPasswordHidden ? "password" : "text",
                            autocomplete: "new-password"
                          },
                          model: {
                            value: _vm.form.newPassword,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form,
                                "newPassword",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.newPassword"
                          }
                        }),
                        _c("i", {
                          staticClass: "fas fa-eye revealer",
                          style: {
                            color: !this.newPasswordHidden ? "#333" : "#CCC"
                          },
                          on: {
                            click: function($event) {
                              return _vm.newPasswordToggle()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "errorsection" }, [
                      _c(
                        "label",
                        {
                          staticClass: "text-error-msg",
                          style: {
                            visibility: _vm.errorFields.newPasswordError
                              ? "visible"
                              : "hidden"
                          }
                        },
                        [_vm._v(_vm._s(_vm.errorFields.newPasswordError))]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "credential-field col-12 col-md-6 col-lg-4 col-xl-3 order-3 order-md-4 order-lg-3",
                    on: {
                      click: function($event) {
                        return _vm.clearErrors("confirmPassword")
                      }
                    }
                  },
                  [
                    _c("div", [
                      _c("label", [
                        _vm._v("Confirm Password"),
                        _c("span", { staticClass: "star" }, [_vm._v("*")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "password-field" },
                      [
                        _c("b-form-input", {
                          staticClass: "password-input",
                          attrs: {
                            id: _vm.subItem.CarrierName + "confirm-password",
                            name: "confirm-password",
                            type: _vm.confirmPasswordHidden
                              ? "password"
                              : "text",
                            autocomplete: "new-password"
                          },
                          model: {
                            value: _vm.form.confirmPassword,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form,
                                "confirmPassword",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.confirmPassword"
                          }
                        }),
                        _c("i", {
                          staticClass: "fas fa-eye revealer",
                          style: {
                            color: !this.confirmPasswordHidden ? "#333" : "#CCC"
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmPasswordToggle()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "errorsection" }, [
                      _c(
                        "label",
                        {
                          staticClass: "text-error-msg",
                          style: {
                            visibility: _vm.errorFields.confirmPasswordError
                              ? "visible"
                              : "hidden"
                          }
                        },
                        [_vm._v(_vm._s(_vm.errorFields.confirmPasswordError))]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "credential-field col-12 col-md-6 col-lg-12 col-xl-3 order-4 order-md-3 order-lg-4"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.submitNewCredentials()
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "ml-1" }, [
                          _vm._v("Save & Update")
                        ])
                      ]
                    )
                  ]
                )
              ])
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5e2dcb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5e2dcb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/agencies/CredentialUpdater.vue
// module id = null
// module chunks = 